import { ListManager, PageHeader, Styles } from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import reports from '@/services/api/reports'
import React from 'react'
import FilterAdoptions from '../../components/FilterAdoptions'

function AdoptionsByFamilyIncome({ title }) {
  usePageTitle({ title })
  const query = useQuery()
  const { data, loading, error } = useAxiosRequest(
    reports.adoptionsByFamilyIncome,
    query,
  )

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Relatório de adoções por renda familiar"
        subtitle="Lista de adoções confirmadas por renda familiar dos adotantes"
        icon="fas fa-money-bill"
        rightAction={() => <FilterAdoptions donors={data?.donors} />}
      />
      <ListManager
        count={data?.rows?.length || 0}
        loading={loading}
        error={error}
      >
        {Boolean(data) && (
          <table className="table table-hover text-small">
            <thead>
              <tr>
                <th>Renda Familiar</th>
                <th className="text-right" width="300px">
                  Quantidade de adoções
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.rows.map((row) => (
                <tr key={row?.renda_familiar}>
                  <td>{row?.renda_familiar}</td>
                  <td className="text-right">{row?.total}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </ListManager>
    </Styles.Container>
  )
}

export default AdoptionsByFamilyIncome
